// extracted by mini-css-extract-plugin
export default {"flexInline":"QfzYAiJ7sc0y5VUhKows","wysig":"MsaXNk1TumKhrMaSXKoZ","exampleTitle":"dUX4WLHaeHlsR2ndcy4O","exampleMessage":"rrGkahU8kUZ39p2lzb1U"};